import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import * as S from "./styles";
import axios from "axios";
import { editCompleteText, PresignedUrlProps, uploadPresignedUrl } from "../../store";
import { useDispatch } from "react-redux";

const InputCompleteSubText = ({ completeText }: { completeText: string }) => {
  const dispatch = useDispatch();

  const handleDescriptionChange = async (value: string) => {
    const imgSrc = value.match(/<img src="data:.*?">/g);
    let newValue = value;
    let hasBigImage = false;
    if (imgSrc) {
      imgSrc.forEach((src) => {
        const base64Data = src.match(/data:(.*?);base64,(.*)"/);
        if (base64Data) {
          const base64String = base64Data[2];

          // Base64 문자열에서 실제 파일 크기 계산 (4/3로 증가하므로 그에 맞춰 계산)
          const fileSizeInBytes =
            (base64String.length * 3) / 4 -
            (base64String.indexOf("=") > -1
              ? base64String.length - base64String.indexOf("=") - 1
              : 0);

          if (fileSizeInBytes > 1048576) {
            // 1MB = 1048576 bytes
            alert("이미지 크기는 1MB를 초과할 수 없습니다.");
            newValue = newValue.replace(src, "");
            hasBigImage = true;
          }
        }
      });
    }

    if (imgSrc && !hasBigImage) {
      // 모든 이미지 업로드 작업을 기다리기 위해 Promise.all 사용
      await Promise.all(
        imgSrc.map(async (src) => {
          const base64Data = src.match(/data:(.*?);base64,(.*)"/);
          if (base64Data) {
            const mimeType = base64Data[1]; // MIME 타입 추출
            const base64String = base64Data[2]; // Base64 데이터 추출

            // Base64 문자열을 디코딩하여 Uint8Array로 변환
            const byteCharacters = atob(base64String);
            const byteNumbers = new Array(byteCharacters.length);
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            // Uint8Array를 Blob 객체로 변환
            const blob = new Blob([byteArray], { type: mimeType });

            // Blob 객체를 File 객체로 변환
            const file = new File([blob], "uploaded_image", { type: mimeType });

            // 파일 업로드 및 URL 교체
            const savedFileUrl = await uploadPresignedUrl(file);
            newValue = newValue.replace(src, `<img src="${savedFileUrl}">`);
          }
        }),
      );
    }

    dispatch(editCompleteText({ completeText: newValue }));
  };

  const customColors = [
    "#000000",
    "#e60000",
    "#ff9900",
    "#ffff00",
    "#008a00",
    "#0B24FB",
    "#777777",
    "#ffffff",
    "#facccc",
    "#ffebcc",
    "#ffffcc",
    "#cce8cc",
    "#cce0f5",
    "#CBCBCB",
  ];

  return (
    <S.Container>
      <S.Text>상세내용</S.Text>
      <ReactQuill
        value={completeText || ""}
        onChange={handleDescriptionChange}
        placeholder="완료페이지 상세 설명을 입력해주세요."
        modules={{
          toolbar: [
            ["bold"],
            [{ color: customColors }, { background: customColors }],
            // [{ align: [] }],
            ["link", "image"],
            ["clean"],
          ],
        }}
        formats={[
          "header",
          "font",
          "list",
          "bullet",
          "bold",
          "italic",
          "underline",
          "strike",
          "blockquote",
          "color",
          "background",
          "align",
          "link",
          "image",
          "strong",
          "li",
        ]}
        style={{ height: "400px" }}
      />
    </S.Container>
  );
};

export default InputCompleteSubText;
